const FOLLOW_UP_REDUX_CONSTANT = {
  GET_FILTERED_FOLLOW_UPS: 'GET_FILTERED_FOLLOW_UPS',
  GET_OPPORTUNITY_DETAIL: 'GET_OPPORTUNITY_DETAIL',
  CLEAR_OPPORTUNITY_DETAIL: 'CLEAR_OPPORTUNITY_DETAIL',
  UPDATE_OPPORTUNITY_DETAIL: 'UPDATE_OPPORTUNITY_DETAIL',
};
export default FOLLOW_UP_REDUX_CONSTANT;
